import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=997caae8&"
import script from "./StudentHistory.vue?vue&type=script&lang=js&"
export * from "./StudentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports